import { render, staticRenderFns } from "./QRGenerator.vue?vue&type=template&id=31d728a4&scoped=true&"
import script from "./QRGenerator.vue?vue&type=script&lang=js&"
export * from "./QRGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d728a4",
  null
  
)

export default component.exports